<template>
  <div class="check_like" :class="{ button_type: type === 'button' }">
    <label>
      <input type="checkbox" :checked="isChecked" />
      <p v-if="hasSlot" class="f15m">
        <slot></slot>
      </p>
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed, useSlots } from "vue";

interface Props {
  type?: string;
  isChecked?: boolean;
}
withDefaults(defineProps<Props>(), {
  type: undefined,
  isChecked: false,
});

const slots = useSlots();
const hasSlot = computed(() => !!slots.default);
</script>
